<template>
	<div class="criteria">
    <span class="criteria-icon"><img :src="criteriaIcon"/></span>
		<!--<span class="criteria-icon"><font-awesome-icon :icon="criteriaIcon" :style="{ fontSize: iconSize }" /></span>-->
		<!--<span class="criteria-name">{{ name }}</span>-->
	</div>
</template>

<script>
	export default {
		name: 'CriteriaIcon',
		props: {
			name: {
				type: String,
				default: ''
			},
			iconSize: {
				type: String,
				default: '1rem'
			}
		},
		computed: {
			key () {
				if (this.name !== '') {
					return this.name.toLowerCase().replace(' ', '_')
				}

				return ''
			},
			criteriaIcon () {
				if (this.key === 'kinderfreundlich' ||
					this.key === 'child_friendly' || 
					this.key === 'adatto_ai_bambini' ||
					this.key === 'otrokom_prijazno') 
				{

					//return ['fal', 'child']
          return '/img/icons_leistungen/kind.svg';
				}

				if (this.key === 'hunde' || 
					this.key === 'dogs' ||
					this.key === 'canino' ||
					this.key === 'canine')
				{
					//return ['fal', 'dog']
          return '/img/icons_leistungen/hund.svg';
				}

				if (this.key === 'behindertengerecht' || 
					this.key === 'wheelchair_accessible' || 
					this.key === 'accesso_disabili' ||
					this.key === 'neomejen_dostop')
				{
					//return ['fal', 'wheelchair']
          return '/img/icons_leistungen/beeintraechtigt.svg';
				}

				if (this.key === 'kinderwagen' ||
					this.key === 'stroller'||
					this.key === 'passeggino' ||
					this.key === 'otroški_voziček')
				{
					//return ['fal', 'baby-carriage']
          return '/img/icons_leistungen/schnuller.svg';
				}
        if (this.key === 'kinderfreundlich') {
          return '/img/icons_leistungen/kind.svg';
        }
        if (this.key === 'oezivzertifiziert') {
          return '/img/icons_leistungen/oeziv_geprueft.svg';
        }
        if (this.key === 'einkaufsvorteil') {
          return '/img/icons_leistungen/shop.svg';
        }
        if (this.key === 'essentrinken') {
          return '/img/icons_leistungen/messer-gabel.svg';
        }
        if (this.key === 'freizeitsport') {
          return '/img/icons_leistungen/freizeitundsport.svg';
        }
        if (this.key === 'ausflugsziel') {
          return '/img/icons_leistungen/kompass.svg';
        }

        //return ['fal', 'angle-double-right']
        return '/img/icons_leistungen/herz-gross.svg';
			}
		}
	}
</script>

<style lang="scss" scoped>
	.criteria{
		display: flex;
		align-items: center;
		margin-left: 1rem;
		margin-bottom: 1rem;

		.criteria-icon,
		.criteria-name {
			display: inline-block;
		}

		.criteria-icon {
			//color: get-color(primary);
      color: $dark-gray;
      background: $white;
      border-radius: 50%;
      height: 60px;
      width: 60px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 30px;
        height: auto;
      }
		}
		.criteria-name{
			margin-left: 1rem;
		}
	}
</style>